import { Component, Inject } from "@angular/core";
import { StateService } from "@uirouter/angular";
import { MatDialog } from "@angular/material/dialog";
import { WorkGroupsDataService } from "../../core/workgroups.dataservice";
import { DetailsBase } from "../../settings/shared/details.base";

@Component({
    selector: "crew-work-group",
    template: require('./work-group.component.html')
})
export class WorkGroupComponent extends DetailsBase<Nema.Crew.Model.WorkGroup> {

    constructor(
        stateService: StateService,
        dialog: MatDialog,
        @Inject('workGroup') workGroupEntity: Nema.Crew.Model.WorkGroup,
        @Inject('workplaces') public workplaces: Nema.Crew.Model.Workplace[],
        @Inject('persons') public persons: Nema.Crew.Model.Person[],
        @Inject(WorkGroupsDataService.Id) workGroupDataService: WorkGroupsDataService,
        @Inject('$log') $log: ng.ILogService) {

        super(stateService, dialog, workGroupEntity, workGroupDataService, $log);

        (<any>this.entity.WorkGroupPersons).load();
    }

    public entityName = "Work Group";

    public editStateName = "app.resources.workgroups.edit";

    public listStateName = "app.resources.workgroups";
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/resources/workgroups/work-group.component.ts